<template>
  <WaggonInfoBody
    :color="workpackage.color"
    :work_package="workpackage"
    :info_box="wallet?false:true"
    :wallet="wallet"
    >

    <template #body-content>
      <!-- <StandardFlexBox>
        TAKT.costs
        <div style="width: 33.6%; line-height: 33px; text-align: center;"><b></b></div>
          <StandardDataField
            value="Tendered"
            width="20%"
            :readonly="true"
            icon="shopping_cart"
            icon_actual="true"
            />
          <div style="width: 4.5%; line-height: 33px; text-align: center;"></div>
        <StandardDataField
          value="Paid out"
          width="20%"
          :readonly="true"
          icon="attach_money"
          icon_actual="true"
          />
      </StandardFlexBox> -->
      <StandardFlexBox>
        TAKT.costs
        <div style="width: 33.6%; line-height: 33px; text-align: center;"><b></b></div>
        <!-- <div style="width: 47%; line-height: 33px; text-align: center;"><b></b></div> -->
          <StandardDataField
            :value="workpackage.costs_paid_out_labour + workpackage.costs_paid_out_material + '€'"
            :color="workpackage.color + ' lighten-3'"
            width="20%"
            icon="payments"
            icon_actual="true"
            :readonly="true"
            :rtl="true"
            />

            <div style="width: 4.5%; line-height: 33px; text-align: center;">/</div>
            <StandardDataField
              :value="workpackage.costs_tendered_labour + workpackage.costs_tendered_material + '€'"
              :color="workpackage.color + ' lighten-2'"
              width="20%"
              icon="shopping_cart"
              icon_actual="true"
              :readonly="true"
              :rtl="true"
              />
      </StandardFlexBox>
      <v-divider color="black"></v-divider>
        <StandardFlexBox
          >
          <!-- Legende -->
          <StandardFlexBox>
            <div style="width: 22%; line-height: 33px; text-align: center;"><b></b></div>

            <StandardDataField
            value="Labour"
            width="20%"
            icon="accessibility"
            :readonly="true"
            />
            <div style="width: 5%; line-height: 33px; text-align: center;"></div>
            <StandardDataField
              value="Material"
              width="20%"
              icon="view_module"
              :readonly="true"
              />
            <div style="width: 4.5%; line-height: 33px; text-align: center;"></div>
            <StandardDataField
              value="     +"
              width="20%"
              icon="accessibility"
              append_icon="view_module"
              :readonly="true"
              />
          </StandardFlexBox>
          <!-- Budget -->
          <StandardFlexBox
            class="pa-1"
            :width="'100%'"
            >
            <StandardFlexBox v-if="!isNaN(workpackage.costs_budget_labour + workpackage.costs_budget_material)">
              <StandardDataField
                width="20%"
                value="Budget"
                icon="account_balance_wallet"
                :readonly="true"
                />
              <div style="width: 2%; line-height: 33px; text-align: center;"><b></b></div>

              <StandardDataField
              :value="workpackage.costs_budget_labour"
              width="20%"
              :type="'number'"
              :readonly="true"
              :rtl="true"
              />
              <div style="width: 5%; line-height: 33px; text-align: center;">+</div>
              <StandardDataField
                :value="workpackage.costs_budget_material"
                width="20%"
                :type="'number'"
                :readonly="true"
                :rtl="true"
                />
              <div style="width: 5%; line-height: 33px; text-align: center;">=</div>
              <StandardDataField
                :value="workpackage.costs_budget_labour + workpackage.costs_budget_material + '€'"
                :color="workpackage.color + ' darken-2'"
                width="20%"
                :readonly="true"
                :rtl="true"
                />
            </StandardFlexBox>
          </StandardFlexBox>
          <!-- Tendered -->
          <StandardFlexBox
            class="pa-1"
            :width="'100%'"
            >
            <StandardFlexBox>
              <StandardDataField
                width="20%"
                value="Tendered"
                icon="shopping_cart"
                :readonly="true"
                />
              <div style="width: 2%; line-height: 33px; text-align: center;"><b></b></div>

              <StandardDataField
              :value="workpackage.costs_tendered_labour"
              width="20%"
              :type="'number'"
              :readonly="true"
              :rtl="true"
              />
              <div style="width: 5%; line-height: 33px; text-align: center;">+</div>
              <StandardDataField
                :value="workpackage.costs_tendered_material"
                width="20%"
                :type="'number'"
                :readonly="true"
                :rtl="true"
                />
              <div style="width: 5%; line-height: 33px; text-align: center;">=</div>
              <!-- :value="workpackage.costs_tendered_labour + workpackage.costs_tendered_material + '€'" -->
              <StandardDataField
                :color="workpackage.color + ' lighten-2'"
                :value="(workpackage.costs_tendered_labour * (workpackage.manpower_actual * workpackage.duration_actual)) + workpackage.costs_tendered_material"
                width="20%"
                :readonly="true"
                :rtl="true"
                />
            </StandardFlexBox>
          </StandardFlexBox>
          <!-- Paid out -->
          <StandardFlexBox
            class="pa-1"
            :width="'100%'"
            >
            <StandardFlexBox>
              <StandardDataField
                width="20%"
                value="Paid out"
                icon="payments"
                :readonly="true"
                />
              <div style="width: 2%; line-height: 33px; text-align: center;"><b></b></div>

              <StandardDataField
              :value="workpackage.costs_paid_out_labour"
              width="20%"
              :type="'number'"
              :readonly="true"
              :rtl="true"
              />
              <div style="width: 5%; line-height: 33px; text-align: center;">+</div>
              <StandardDataField
                :value="workpackage.costs_paid_out_material"
                width="20%"
                :type="'number'"
                :readonly="true"
                :rtl="true"
                />
              <div style="width: 5%; line-height: 33px; text-align: center;">=</div>
              <StandardDataField
                :color="workpackage.color + ' lighten-3'"
                :value="workpackage.costs_paid_out_labour + workpackage.costs_paid_out_material + '€'"
                width="20%"
                :readonly="true"
                :rtl="true"
                />
            </StandardFlexBox>
          </StandardFlexBox>
        </StandardFlexBox>
    </template>
  </WaggonInfoBody>
</template>
<script>
import store from '@/store/index'

import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'

export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'workpackage', 'wallet'],
  mixins: [
    WaggonInfoMixin
  ],
  beforeRouteUpdate(to, from, next) {
    store.dispatch('Ultra/requestUObject', {
        url: [
          {projects: to.params.project_id},
          {trains: to.params.train_id},
          {taktareas: to.params.taktarea_id},
          {twaggons: to.params.twaggon_id},
          {tworkpackages: to.params.tworkpackage_id},
          {showWithEntitiesNormalized: ''}
        ]
      }).then(() => {next()})
  },
  // beforeRouteUpdate(to, from, next) {
  //   store.dispatch('TWorkPackage/requestTWorkPackage', {
  //     project_id: to.params.project_id,
  //     train_id: to.params.train_id,
  //     taktarea_id: to.params.taktarea_id,
  //     twaggon_id: to.params.twaggon_id,
  //     twork_package_id: to.params.tworkpackage_id
  //   }).then(() => {next()})
  // },
}
</script>
<style>
  div {
    user-select: none;
  }
</style>

<!-- 500€ von 1000€ gezahlt -->
